import { IShipmentLocation } from '@cemex-core/cmx-api';
import { createAction, props } from '@ngrx/store';


export const setActive = createAction(
  '[MOO/MODAL/Shipment Location] Set Active Entity',
  props<{ shipmentLocationId: number | string }>(),
);

export const fetch = createAction(
  '[MOO/MODAL/Shipment Location] Fetch start',
);

export const fetchSuccess = createAction(
  '[MOOE/MODAL/Shipment Location] Fetch success',
  props<{ payload: IShipmentLocation[] }>(),
);

export const fetchFailed = createAction(
  '[MOO/MODAL/Shipment Location] Fetch failed',
);

export const resetShipmentLocationState = createAction(
  '[MOO/MODAL/Shipment Location] Reset State',
);

const ShipmentLocationActions = {
  setActive,

  fetch,
  fetchSuccess,
  fetchFailed,

  resetShipmentLocationState,
};

export default ShipmentLocationActions;
